import React, {useMemo, useState} from 'react';
import * as Icon from 'antd-mobile-icons';
import * as AntdIcons from '@ant-design/icons';
import {IconType} from '../../Utils/publicEnum';
import Style from './index.module.scss';

interface Props {
    type: IconType;
    value: string;
    className?: string;
    onClick?: () => void;
}
const Index = ({type, value, className, onClick}: Props) => {
    const [svgContent, setSvgContent] = useState<string | null>(null);
    function getSvg(url: string) {
        fetch(url)
            .then(res => res.text())
            .then(data => {
                setSvgContent(data);
            });
    }

    if (type === IconType.WebSvg) {
        getSvg(value);
    }

    const IconNode = useMemo(() => {
        if (value.includes('/') || value.includes('http')) {
            return React.createElement(Icon['SmileFill']);
        }
        let Components = null;
        switch (type) {
            case IconType.WebSvg:
                return (
                    <div dangerouslySetInnerHTML={{__html: svgContent || ''}} />
                );
            case IconType.WebImg:
                return <img src={value} alt="" />;
            case IconType.AntdMobile:
                Components = Icon?.[value as keyof typeof Icon];
                return Components ? <Components /> : <div>NULL-{value}</div>;
            case IconType.Antd:
                Components = AntdIcons?.[value as keyof typeof AntdIcons];
                // @ts-ignore
                return Components ? <Components /> : <div>NULL-{value}</div>;
            default:
                return <div>NULL-{value}</div>;
        }
    }, [type, svgContent, value]);

    return (
        <div className={className} onClick={onClick}>
            {IconNode}
            {[IconType.AntdMobile, IconType.Antd].includes(type) && (
                <p className={Style.info}>{value}</p>
            )}
        </div>
    );
};

export default Index;
